export const COMPANY_URL = '/company';
export const PAYMENT_URL = '/payment_terms';
export const ASSIGN_URL = '/company/assign-process';